module.exports = __webpack_public_path__ + "static/media/Banner_Tablet.1cead24a.jpg";